import { Box } from '@material-ui/core';
import { OnlineOnboardingDetails } from '@nemuru-eng/js-api-client';

import { DetailsDataSkeleton } from '@/components/modules/AssetDetails/components/shared/DetailsDataSkeleton';
import { Font } from '@/components/shared/components/Font';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { AutocompleteNationalityFormField } from '@/components/shared/components/NewContextForms/AutocompleteNationalityFormField/AutocompleteNationalityFormField';
import { DateFormField } from '@/components/shared/components/NewContextForms/DateFormField';
import { PhoneFormDoubleField } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/PhoneFormDoubleField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { Text } from '@/components/shared/components/Text';

interface PersonalInformationFormProps extends FormGridOptions {
  borrowerDetails: OnlineOnboardingDetails;
  loading: boolean;
}

export function PersonalInformationForm({
  borrowerDetails,
  fieldVariant,
  fullWidth,
  loading,
}: PersonalInformationFormProps) {
  return (
    <Box pt={2}>
      {loading ? (
        <DetailsDataSkeleton numberOfRows={8} />
      ) : (
        <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth}>
          <TextFormField
            label={'FIRST_NAME'}
            name={'firstName'}
            value={borrowerDetails.invitation.fullName.firstName}
          />
          <TextFormField label={'LAST_NAME'} name={'lastName'} value={borrowerDetails.invitation.fullName.lastName} />
          <TextFormField label={'EMAIL'} name={'email'} value={borrowerDetails.invitation.email} />
          <PhoneFormDoubleField fieldVariant={fieldVariant} defaultValue={borrowerDetails.invitation.phoneNumber} />
          <TextFormField
            label={'DOCUMENT_ID_NUMBER'}
            name={'documentNumber'}
            value={borrowerDetails.invitation.documentNumber}
          />
          <DateFormField
            name={'documentExpirationDate'}
            label={'DOCUMENT_EXPIRATION_DATE'}
            value={borrowerDetails.documentExpirationDate}
            disableFuture
          />
          <DateFormField name={'birthDate'} label={'BIRTH_DATE'} value={borrowerDetails.birthDate} disableFuture />
          <AutocompleteNationalityFormField
            name={'nationality'}
            label={'NATIONALITY'}
            value={borrowerDetails.nationality}
            fieldVariant={fieldVariant}
          />
        </FormGridContainer>
      )}
      <Box mt={3} />
      <Font variant={'h4'} color={'textSecondary'}>
        <Text tId={'ADDRESS'} />
      </Font>
      <Box mt={2} />
      {loading ? (
        <DetailsDataSkeleton numberOfRows={4} />
      ) : (
        <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth}>
          <TextFormField
            label={'STREET_ADDRESS'}
            name={'streetAddress'}
            value={borrowerDetails.address?.streetAddress}
            multiline
          />
          <TextFormField label={'POSTAL_CODE'} name={'postalCode'} value={borrowerDetails.address?.postalCode} />
          <TextFormField label={'CITY'} name={'city'} value={borrowerDetails.address?.city} />
          <TextFormField label={'COUNTRY'} name={'country'} value={borrowerDetails.address?.country} />
        </FormGridContainer>
      )}
    </Box>
  );
}
